import { receiveData, receiveError } from '../api/http'
import CloudFlyerAPI from '../api/CloudFlyerAPI'

export const FETCH_SYNC_INFO_WASABI_SUCCESS = 'FETCH_SYNC_INFO_WASABI_SUCCESS'
export const FETCH_SYNC_INFO_WASABI_ERROR   = 'FETCH_SYNC_INFO_WASABI_ERROR'

export function fetchSyncInfoWasabi() {
  return (dispatch, getState) => {
    CloudFlyerAPI
      .user_account
      .fetchSyncInfoAllWasabi()
      .then(({ data }) => {
        dispatch(receiveData(FETCH_SYNC_INFO_WASABI_SUCCESS, data))
      })
      .catch(err => {
        dispatch(receiveError(FETCH_SYNC_INFO_WASABI_ERROR, err))
      })
  }
}
